const applicantModalGlobal = {
  current: (
    _applicantDetailId: number | null,
    _applicantCollectionIds: number[]
  ) => true
}

export const getApplicantModalGlobalRef = (): typeof applicantModalGlobal =>
  applicantModalGlobal
